import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import api from '../services/api';
import { authService } from '../services/auth';
import './ChoosePlanPage.css';

export default function ChoosePlanPage() {
  const [selectedPlan] = useState('yearly');
  const [loadingPlan, setLoadingPlan] = useState(null);
  const [checkingSubscription, setCheckingSubscription] = useState(true);
  const navigate = useNavigate();

  // Check if user is already a paid subscriber on component mount
  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      try {
        console.log('[ChoosePlan] Checking subscription status...');
        const response = await api.get('/api/check-subscription', {
          headers: { Authorization: `Bearer ${authService.getToken()}` },
        });
        
        console.log('[ChoosePlan] Subscription check response:', response);
        
        if (response.is_paid) {
          console.log('[ChoosePlan] User is already paid, redirecting to download page');
          // User is already a paid subscriber, redirect to download page
          navigate('/premium-download');
          return;
        }
        
        console.log('[ChoosePlan] User is not paid, showing plan selection');
      } catch (error) {
        console.error('[ChoosePlan] Error checking subscription:', error);
        // If there's an error, just show the plan selection page
      } finally {
        setCheckingSubscription(false);
      }
    };

    checkSubscriptionStatus();
  }, [navigate]);

  const handleSelect = async (period) => {
    console.log('[ChoosePlan] handleSelect called with period:', period);
    console.log('[ChoosePlan] Auth token:', authService.getToken());
    setLoadingPlan(period);
    try {
      const payload = {
        billing_period: period,
        action: 'load_more',
        quantity: 100,
        return_url: `${window.location.origin}/premium-download`,
      };
      console.log('[ChoosePlan] Creating checkout session', payload);
      const data = await api.post('/api/create-checkout-session', payload, {
        headers: { Authorization: `Bearer ${authService.getToken()}` },
      });
      if (data?.url) {
        window.location = data.url;
      } else {
        alert('Unable to start checkout. Please try again.');
      }
    } catch (err) {
      console.error('[ChoosePlan] checkout error', err);
      alert('Checkout failed – see console for details');
    } finally {
      setLoadingPlan(null);
    }
  };

  const features = [
    'Unlimited prospect searches',
    'Advanced AI-powered matching',
    'Real-time contact verification',
    'Priority customer support'
  ];

  const PlanCard = ({ 
    title, 
    price, 
    originalPrice, 
    period, 
    isPopular, 
    savings, 
    
    description 
  }) => (
    <div
      className={`plan-card ${selectedPlan === period ? 'selected' : ''}`}
      onClick={() => handleSelect(period)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSelect(period);
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`Select ${title} plan for $${price} ${period === 'monthly' ? 'per month' : 'per year'}`}
    >
      {isPopular && (
        <div className="popular-badge">
          MOST POPULAR
        </div>
      )}
      
      <div className="plan-content">
        
        <h3 className="plan-title">{title}</h3>
        <p className="plan-description">{description}</p>
        
        <div className="pricing">
          {originalPrice && (
            <div className="original-price">${originalPrice}</div>
          )}
          <div className="current-price">${price}</div>
          <div className="billing-period">
            {period === 'monthly' ? 'per month' : 'per year'}
          </div>
          {savings && (
            <div className="savings-badge">Save {savings}%</div>
          )}
        </div>
      </div>

      <button
        className={`plan-button ${selectedPlan === period ? 'selected' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          handleSelect(period);
        }}
        disabled={loadingPlan !== null}
      >
        {loadingPlan === period ? 'Processing...' : 'Get Started'}
      </button>
    </div>
  );

  // Show loading state while checking subscription
  if (checkingSubscription) {
    return (
      <div className="choose-plan-page">
        <div className="background-animation"></div>
        <div className="container">
          <div className="content">
            <div className="header">
              <h1 className="main-title">Checking your subscription...</h1>
              <p className="subtitle">Please wait while we verify your account status</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

    return (
    <div className="choose-plan-page">
      <div className="background-animation"></div>

      <div className="container">
        <div className="content">
          {/* Header */}
          <div className="header">
            <h1 className="main-title">Unlock Your Growth</h1>
            <p className="subtitle">
              Choose the perfect plan to supercharge your outreach and convert more prospects into customers
            </p>
          </div>

          {/* Plans */}
          <div className="plans-grid">
            <PlanCard
              title="Growth"
              description="Perfect for growing teams"
              price="200"
              period="monthly"
              

            />
            <PlanCard
              title="Scale"
              description="Best value for serious growth"
              price="2000"
              originalPrice="2400"
              period="yearly"
              isPopular={true}
              savings={17}
              

            />
          </div>

          {/* Features */}
          <div className="features-section">
            <h2 className="features-title">Everything you need to succeed</h2>
            <div className="features-grid">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <span className="feature-check">✓</span>
                  <span className="feature-text">{feature}</span>
                </div>
              ))}
            </div>
          </div>
          </div>
        </div>
      </div>
  );
}
